<div class="modal-header">
	<h3 class="modal-title">
		@if (readonly()) {
			<span>{{ ('Actions.Request' | translate) + ' #' + form.get('portalRequestFunctionalId').value }}</span>
		} @else {
			{{ 'PortalRequests.Modal.Title' | translate }}
		}
	</h3>
	@if (readonly()) {
		<portal-request-status-button [request]="form.value" [disabled]="true"/>
	}
</div>

<div class="modal-body" [formGroup]="form">
	@if (form.get('requestType'); as field) {
		<div class="form-group">
			<label class="form-label" for="field-requestType" translate="PortalRequests.Modal.Type.Label"></label>
			<select id="field-requestType" class="form-control form-control-alt" formControlName="requestType">
				<option [ngValue]="DunningLevel.PAA" translate="PortalRequests.Modal.Type.PAA"></option>
				<option [ngValue]="DunningLevel.PPA" translate="PortalRequests.Modal.Type.PPA"></option>
				<option [ngValue]="DunningLevel.LTG" translate="PortalRequests.Modal.Type.LTG"></option>
			</select>
			<form-control-feedback [field]="field"/>
		</div>
	}
	@if (form.get('email'); as field) {
		<div class="form-group">
			<label class="form-label" for="field-email" translate="PortalRequests.Modal.Email">
				<popover-component [content]="'PortalRequests.EmailTooltip' | translate" triggers="focus hover"/>
			</label>
			<input id="field-email" class="form-control form-control-alt" formControlName="email"/>
			<form-control-feedback [field]="field"/>
		</div>
	}
	@if (needDate() && form.get('paymentDate'); as field) {
		<div class="form-group">
			<label class="form-label" for="field-paymentDate" translate="PortalRequests.Modal.PaymentDate"></label>
			<form-datepicker
				[forcePropagation]="field.dirty"
				formControlName="paymentDate"
				inputClass="form-control-alt"
				[class.is-invalid]="field.dirty && field.invalid"
				[control]="field"
				controlId="field-payment-date"
				[minDate]="tmrow"
			/>
			<form-control-feedback [field]="field"/>
		</div>
	}
	@if (needComment() && form.get('comment'); as field) {
		<div class="form-group">
			<label class="form-label" for="field-comment" translate="PortalRequests.Modal.Comment"></label>
			<textarea id="field-comment" class="form-control form-control-alt" formControlName="comment" rows="2"></textarea>
			<form-control-feedback [field]="field"/>
		</div>
	}
</div>

<div class="modal-footer modal-footer-reverse">
	@if (readonly()) {
		<button type="button" class="btn btn-default" data-cy="ConfirmNo" ngbAutofocus
			(click)="dismiss()">{{ 'Actions.Close' | translate }}
		</button>
	} @else {
		<button type="button" class="btn btn-secondary" data-cy="ConfirmYes"
			[disabled]="!form.valid"
			(click)="submit()">{{ 'Actions.Validate' | translate }}
		</button>
		<button type="button" class="btn btn-default" data-cy="ConfirmNo" ngbAutofocus
			(click)="dismiss()">{{ 'Actions.Cancel' | translate }}
		</button>
	}
</div>
